import type { NftMiniature } from "@anaconda/core/nft/types"
import type { Blockchain, Order } from "@rarible_int/anaconda_sdk/ethereum"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { useSwitchEvmChain } from "../../use-switch-evm-chain"
import { EvmAcceptBidTransactionMoleculeReatom } from "./evm-accept-bid-molecule.reatom"

export interface EvmAcceptBidParams {
  nft: NftMiniature
  order: Order
}

export function useEvmAcceptBid(blockchain: Blockchain) {
  const { acceptBidActionFactory } = useMolecule(
    EvmAcceptBidTransactionMoleculeReatom,
  )
  const acceptBidAction = useMemo(
    () => acceptBidActionFactory(),
    [acceptBidActionFactory],
  )

  const onSuccess = useCallback(
    (params: EvmAcceptBidParams) => {
      acceptBidAction({ ...params, blockchain }).catch(() => undefined)
    },
    [acceptBidAction, blockchain],
  )

  const { action, switchInProgress } = useSwitchEvmChain<EvmAcceptBidParams>(
    blockchain,
    onSuccess,
  )

  return {
    mutate: action,
    isPending: !!acceptBidAction.pending() || switchInProgress,
  }
}
